<template>
  <div class="hero-body has-text-centered">
    <h1 class="title">
      Not found
    </h1>
    <b-message type="is-danger" has-icon>
      Oops, 404 not found.
      You can try again starting from the <router-link to="/">main page</router-link>
    </b-message>
  </div>
</template>

<script>
export default {
  name: 'NotFoundComponent',
  data () {
    return {}
  }
}
</script>

<style scoped>

</style>
